module.exports = __webpack_public_path__ + "static/media/linkedIn.7041453c.png";